import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

// The default strategy reuses components when only :tenantId changes, leaving ngOnInit-fetched tenant data stale.
@Injectable()
export class TenantRouteReuseStrategy extends BaseRouteReuseStrategy {
    override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return super.shouldReuseRoute(future, curr)
            && future.params['tenantId'] === curr.params['tenantId'];
    }
}
